import { render } from "./PlanFooter.vue?vue&type=template&id=4408ed1c"
import script from "./PlanFooter.vue?vue&type=script&lang=js"
export * from "./PlanFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__